var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.spinner)?_c('b-spinner',{attrs:{"variant":"success"}}):_c('a',{attrs:{"title":"Gnres"},on:{"click":function($event){return _vm.print_gnres([_vm.item.id], true)}}},[_c('i',{staticClass:"fas fa-poo ml-2"})])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d2e76ac2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/Orders_v2/Aggregates/Gnres.vue
// module id = UZ58
// module chunks = 0